import React from 'react';
import Button from '@atlaskit/button/standard-button';
import Modal, {
	ModalBody,
	ModalFooter,
	ModalHeader,
	ModalTitle,
	ModalTransition,
} from '@atlaskit/modal-dialog';
import { Text } from '@atlaskit/primitives';
import { useContent } from './utils';

type Props = {
	isModalOpen: boolean;
	onContinue: () => void;
	onCancel: () => void;
	offsetModalY?: number;
};

export const UnmappedColumnsWarningModal = ({
	isModalOpen,
	onContinue,
	onCancel,
	offsetModalY,
}: Props) => {
	const { title, description, nextButtonText, cancelButtonText } = useContent();

	return (
		<ModalTransition>
			{isModalOpen && (
				<Modal onClose={onCancel} stackIndex={(offsetModalY || 0) / 8}>
					<ModalHeader>
						<ModalTitle appearance="warning">{title}</ModalTitle>
					</ModalHeader>

					<ModalBody>
						<Text as="p">{description}</Text>
					</ModalBody>

					<ModalFooter>
						<Button appearance="subtle" onClick={onCancel}>
							{cancelButtonText}
						</Button>
						<Button appearance="warning" onClick={onContinue} autoFocus>
							{nextButtonText}
						</Button>
					</ModalFooter>
				</Modal>
			)}
		</ModalTransition>
	);
};
